import { render, staticRenderFns } from "./staOffice.vue?vue&type=template&id=2625bc0c&scoped=true"
import script from "./staOffice.vue?vue&type=script&lang=js"
export * from "./staOffice.vue?vue&type=script&lang=js"
import style0 from "./staOffice.vue?vue&type=style&index=0&id=2625bc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625bc0c",
  null
  
)

export default component.exports